export default __webpack_public_path__ + "static/media/listing1.78945ab9.jpg";